import { CTA_FETCHED } from "../types";
const initialState = {'enableCallToAction' : false};

export default function cta(state = initialState, action = {}) {
  switch (action.type) {
    case CTA_FETCHED:
          return { ...state, ...action.cta };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cta.js